import {Component, Input, OnInit} from "@angular/core";
import {CmPartnerBaseComponent} from "../cm-partner-base.component";
import {PartnerDto} from "../../../../../model/dto/entity/partner.dto";

@Component({
    selector: 'cm-partner-full',
    templateUrl: 'cm-partner-full.component.html',
    standalone: false
})


export class CmPartnerFullComponent extends CmPartnerBaseComponent implements OnInit {
    @Input() dto: PartnerDto;

    ngOnInit() {
        super.ngOnInit();
    }

}